import React, { createContext, useEffect, useState } from 'react'
import { Outlet, useParams, useSearchParams } from 'react-router-dom'
import { useLocalStorage } from 'react-use'
import { get } from '../Common/api'
import consumer from '../Common/cable'
import dayjs from 'dayjs'

const PublicContext = createContext()
export default PublicContext

export const PublicContextProvider = () => {
  const [loading, setLoading] = useState(false)
  const { boxId, appointmentId, appointmentDate } = useParams()
  const [box, setBox] = useState(null)
  const [slots, setSlots] = useState([])
  const [updatedSlots, setUpdatedSlots] = useState(null)
  const [appointment, setAppointment] = useState(null)
  const [params, _] = useSearchParams()
  const [data, setData] = useLocalStorage('appointment')
  const [user, setUser] = useLocalStorage('user')
  const [isNow, setIsNow] = useState(false)
  const [siderTitle, setSiderTitle] = useState(null)
  const [siderDisabled, setSiderDisabled] = useState(false)
  const [appointmentStatus, setAppointmentStatus] = useState(null)

  const getBox = (id) => {
    setLoading(true)
    get({
      url: `public/boxes/${id}`,
      params: {},
      onSuccess: (json) => {
        setBox(json)
        setLoading(false)
      },
      onFailure: () => {
        setLoading(false)
      }
    })
  }

  const getSlots = (id, start, { reset }) => {
    setLoading(true)
    const end = start.add(7, 'day').hour(23).toString()
    start = start.toString()
    get({
      url: `public/boxes/${id}/slots`,
      params: { range_start: start, range_end: end },
      onSuccess: (json) => {
        if (reset) {
          setSlots([...json])
        } else {
          setSlots([...slots, ...json])
        }
        setLoading(false)
      },
      onFailure: () => {
        setLoading(false)
      }
    })
  }

  const getAppointment = () => {
    setLoading(true)
    get({
      url: `public/appointments/${appointmentId}`,
      params: {},
      onSuccess: (json) => {
        setAppointment(json)
        updateStatus(json)
        setLoading(false)
      },
      onFailure: () => {
        setLoading(false)
      }
    })
  }

  const updateStatus = (json) => {
    if (json?.calendoc_timeout) setAppointmentStatus('timeout')
    else if (json?.is_cancel) setAppointmentStatus('cancel')
    else setAppointmentStatus(json.state)
  }

  const updateSlots = (newSlots) => {
    const newUpdatedSlots = slots
    newSlots.forEach(slot => {
      const index = slots.findIndex((s) => s.id === slot.id)
      newUpdatedSlots[index] = { ...slot }
    })
    setSlots([...newUpdatedSlots])
  }

  useEffect(() => {
    if (appointmentId) {
      getAppointment()
    }
  }, [appointmentId])

  useEffect(() => {
    if (appointment && appointment.box.id !== box?.id) {
      setBox(appointment.box)
    }
  }, [appointment])

  useEffect(() => {
    if (boxId) {
      getBox(boxId)
      getSlots(boxId, dayjs(), { reset: true })
    }
    const boxSubscription = consumer.subscriptions.create({ channel: 'PublicSlotsChannel' }, {
      connected: () => { console.log('public connected') },
      disconnected: () => {
        console.log('public disconnected')
      },
      received: (res) => {
        setUpdatedSlots(res)
      }
    })
    return () => {
      boxSubscription.unsubscribe()
    }
  }, [boxId])

  useEffect(() => {
    if (updatedSlots) {
      updateSlots(updatedSlots)
    }
  }, [updatedSlots])

  useEffect(() => {
    setIsNow(appointmentDate === 'now')
  }, [appointmentDate])

  const values = {
    box,
    isNow,
    params,
    loading,
    setLoading,
    siderTitle,
    setSiderTitle,
    setData,
    data,
    siderDisabled,
    setSiderDisabled,
    appointment,
    setAppointment,
    appointmentStatus,
    updateStatus,
    getSlots,
    slots,
    user,
    setUser
  }

  return <PublicContext.Provider value={values}>
    <Outlet />
  </PublicContext.Provider>
}
